import React from 'react';
import { css } from '@emotion/react';
import theme from '@styles/theme';
import { setCustomNameToText } from '@service/ChapterService';
import { useChatPlayContext } from '@provider/ChatPlayProvider';
import { useAppSelector } from '@store/hooks';
import { RootState } from '@store/store';
import { Choice } from '@/customTypes/chatStory';
import { shallowEqual } from 'react-redux';
import ChoiceImageList from './ChoiceImageList';

interface IChoiceItem {
  onChoice: ({
    choiceName,
    choiceItem: { choiceIndex, selectedName },
  }: {
    choiceName: string;
    choiceItem: {
      choiceIndex: number;
      selectedName: string;
    };
  }) => void;
}

const ChoiceList = ({ onChoice }: IChoiceItem) => {
  const { playChapterInfo } = useAppSelector(
    (state: RootState) => state.chapter,
    shallowEqual,
  );
  const { choice } = useChatPlayContext();

  if (!choice || !playChapterInfo) {
    return null;
  }

  const choiceInfo = choice as Choice;

  return (
    <>
      {choiceInfo?.options?.layoutType === 'ImageChoice' ? (
        <ChoiceImageList />
      ) : (
        <div css={container}>
          <div css={choiceContainer}>
            {choiceInfo.options?.layoutType !== 'UserInputChoice' &&
              choiceInfo?.choices?.map((item, index) => {
                return (
                  <button
                    className="item"
                    onClick={() =>
                      onChoice({
                        choiceName: choiceInfo?.choiceName || '',
                        choiceItem: {
                          choiceIndex: index,
                          selectedName: item,
                        },
                      })
                    }
                    key={`${item} ${index}`}
                  >
                    {setCustomNameToText({ text: item, playChapterInfo })}
                  </button>
                );
              })}
          </div>
        </div>
      )}
    </>
  );
};

const container = css`
  height: 100%;
  padding: 2em 0;
  overflow-y: scroll;
  display: grid;
  justify-content: center;
`;

const choiceContainer = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .item {
    padding: 0.75em 1.5em;
    margin: 0.5em 0;
    background-color: ${theme.colors.gray900};
    color: ${theme.colors.white};
    font-size: 1em;
    font-weight: 700;
    border: 0px;
    border-radius: 6px;
    cursor: pointer;

    @media screen and (max-width: ${theme.devices.mobile}) {
      max-width: 335px;
    }
  }
`;

export default ChoiceList;
